var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-container",class:['container-' + _vm.mode, 'align-' + _vm.align, _vm.horizontal ? 'horizontal' : 'vertical',
     { 'limit-visibles': _vm.showLimit, 'fill-parent': _vm.fillParent }]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }